export const PAGINATION_DEFAULT_CONFIG = {
  skip: 0,
  limit: 50,
};
